<template>
  <v-container fluid>
    <v-card class="mx-auto" elevation="8">
      <v-card-title class="pa-4 primary white--text">
        <v-icon left dark>mdi-school</v-icon>
        <span class="text-h6 font-weight-bold">การจัดการคุณวุฒิการศึกษา</span>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="ค้นหา"
          single-line
          hide-details
          dark
          dense
          class="shrink"
        ></v-text-field>
        <v-btn color="white" class="ml-4 primary--text" @click="openDialog('add')">
          <v-icon left>mdi-plus-circle</v-icon>
          เพิ่มคุณวุฒิ
        </v-btn>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="degrees"
        :search="search"
        :loading="loading"
        loading-text="กำลังโหลดข้อมูล..."
        class="elevation-0"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="openDialog('edit', item)" v-bind="attrs" v-on="on">
                mdi-pencil
              </v-icon>
            </template>
            <span>แก้ไข</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small @click="deleteItem(item)" v-bind="attrs" v-on="on">
                mdi-delete
              </v-icon>
            </template>
            <span>ลบ</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-alert :value="true" color="info" icon="mdi-alert-circle">
            ไม่พบข้อมูลคุณวุฒิการศึกษา
          </v-alert>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-container>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    v-model="editedItem.level_code"
                    :items="level_codes"
                    item-text="text"
                    item-value="value"
                    label="ระดับการศึกษา *"
                    :rules="[v => !!v || 'กรุณาเลือกระดับ']"
                    required
                    :disabled="!isAdding" 
                    @change="handleLevelChange"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="editedItem.degree_code"
                    label="รหัสคุณวุฒิ"
                    :disabled="isAdding" 
                    :rules="[v => !!v || 'กรุณากรอกรหัสคุณวุฒิ']"
                    required
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.cls_degree_name"
                    label="ชื่อคุณวุฒิ *"
                    :rules="[v => !!v || 'กรุณากรอกชื่อคุณวุฒิ']"
                    required
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="closeDialog">
            <v-icon left>mdi-close-circle</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn color="primary" @click="save">
            <v-icon left>mdi-content-save</v-icon>
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="error white--text">
          <v-icon left dark>mdi-alert-octagon</v-icon>
          ยืนยันการลบ
        </v-card-title>
        <v-card-text class="pt-4 text-center text-body-1">
          คุณแน่ใจหรือไม่ว่าต้องการลบ **{{ itemToDelete ? itemToDelete.cls_degree_name : '' }}** นี้?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="deleteDialog = false">ยกเลิก</v-btn>
          <v-btn color="red darken-1" @click="confirmDelete">ลบ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" bottom right>
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
export default {
  data: () => ({
    ApiKey: "HRvec2021",
    loading: false,
    search: "",
    dialog: false,
    deleteDialog: false,
    isAdding: true,
    snackbar: { show: false, message: "", color: "" },

    headers: [
      { text: "รหัสคุณวุฒิ", value: "degree_code" },
      { text: "ชื่อคุณวุฒิ", value: "cls_degree_name" },
      { text: "ระดับ", value: "level_name" },
      { text: "จัดการ", value: "actions", sortable: false }
    ],

    degrees: [],
    editedIndex: -1,
    editedItem: {
      degree_id: null,
      degree_code: "",
      cls_degree_name: "",
      level_code: "",
      level_name: ""
    },
    defaultItem: {
      degree_id: null,
      degree_code: "",
      cls_degree_name: "",
      level_code: "",
      level_name: ""
    },
    itemToDelete: null,
    level_codes: [
      { text: "ต่ำกว่า ปริญญาตรี", value: "L" },
      { text: "ปริญญาตรี", value: "B" },
      { text: "ปริญญาโท", value: "M" },
      { text: "ปริญญาเอก", value: "D" }
    ]
  }),

  computed: {
    formTitle() {
      return this.isAdding
        ? "เพิ่มคุณวุฒิการศึกษาใหม่"
        : "แก้ไขคุณวุฒิการศึกษา";
    }
  },

  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
    deleteDialog(val) {
      val || (this.itemToDelete = null);
    }
  },

  created() {
    this.fetchDegrees();
  },

  methods: {
    /**
     * ดึงข้อมูลคุณวุฒิทั้งหมด (Read/Search)
     * API: cls_degree.php
     */
    async fetchDegrees() {
      this.loading = true;
      try {
        const response = await this.$http.post("cls_degree.php", {
          ApiKey: this.ApiKey
        });

        if (Array.isArray(response.data)) {
          this.degrees = response.data;
        } else if (response.data && response.data.error) {
          this.showSnackbar("error", `Error: ${response.data.message}`);
        } else {
          this.degrees = [];
        }
      } catch (error) {
        console.error("API Error (fetchDegrees):", error);
        this.showSnackbar("error", "ไม่สามารถเชื่อมต่อฐานข้อมูลได้");
      } finally {
        this.loading = false;
      }
    },

    /**
     * ดึงรหัสล่าสุดจากฐานข้อมูลตาม level_code ที่เลือก
     * API: cls_degree.latest_code.php
     */
    async fetchLatestDegreeCodeByLevel(levelCode) {
      if (!levelCode) {
        this.editedItem.degree_code = '';
        return;
      }
      this.loading = true;
      try {
        const response = await this.$http.post("cls_degree.latest_code.php", {
          ApiKey: this.ApiKey,
          level_code: levelCode
        });

        const latestCode = response.data && response.data.degree_code ? response.data.degree_code : `${levelCode}000`;
        
        // Logic คำนวณรหัสใหม่: ตัวอักษร + เลข 3 หลัก (padded with zero) + 1
        let prefix = latestCode.substring(0, 1);
        let currentNum = parseInt(latestCode.substring(1), 10);
        let nextNum = currentNum + 1;
        
        this.editedItem.degree_code = prefix + String(nextNum).padStart(3, '0');

      } catch (error) {
        console.error("API Error (fetchLatestDegreeCodeByLevel):", error);
        this.showSnackbar("error", "ไม่สามารถดึงรหัสล่าสุดได้");
        // Fallback: ใช้รหัสเริ่มต้น (Level + 001)
        this.editedItem.degree_code = levelCode + '001'; 
      } finally {
        this.loading = false;
      }
    },
    
    /**
     * Handle Event เมื่อมีการเปลี่ยน Level ในโหมดเพิ่ม
     */
    handleLevelChange(newLevelCode) {
      if (this.isAdding) {
          const selectedLevel = this.level_codes.find(l => l.value === newLevelCode);
          this.editedItem.level_name = selectedLevel ? selectedLevel.text : '';
          this.fetchLatestDegreeCodeByLevel(newLevelCode);
      }
    },

    /**
     * เปิด Dialog สำหรับเพิ่มหรือแก้ไข
     */
    openDialog(mode, item) {
      this.isAdding = mode === "add";
      if (this.isAdding) {
        this.editedItem = Object.assign({}, this.defaultItem);
        // หากมี level_code ที่ถูกเลือกไว้ (เช่นจากการเลือกในอดีต) ให้เริ่มดึงรหัสใหม่
        if (this.editedItem.level_code) {
           this.handleLevelChange(this.editedItem.level_code);
        }
      } else {
        this.editedIndex = this.degrees.indexOf(item);
        this.editedItem = Object.assign({}, item);
        // ในโหมดแก้ไข ต้องหา level_name จาก level_code อีกครั้งเพื่อความสมบูรณ์
        const selectedLevel = this.level_codes.find(l => l.value === this.editedItem.level_code);
        this.editedItem.level_name = selectedLevel ? selectedLevel.text : this.editedItem.level_name;
      }
      this.dialog = true;
    },

    /**
     * บันทึกข้อมูล (Insert/Update)
     */
    async save() {
        // Validation
        if (!this.editedItem.level_code || !this.editedItem.degree_code || !this.editedItem.cls_degree_name) {
            this.showSnackbar("warning", "กรุณากรอกข้อมูลให้ครบถ้วน");
            return;
        }

        let url = "";
        let data = { 
            ApiKey: this.ApiKey, 
            degree_code: this.editedItem.degree_code,
            cls_degree_name: this.editedItem.cls_degree_name
        };

        if (this.isAdding) {
            // Insert: ใช้ degree_code, cls_degree_name, level_code, level_name
            url = "cls_degree.insert.php";
            data.level_code = this.editedItem.level_code;
            data.level_name = this.editedItem.level_name;
        } else {
            // Update: ใช้ degree_id, degree_code, cls_degree_name
            url = "cls_degree.update.php";
            data.degree_id = this.editedItem.degree_id;
            // API update ไม่ได้รับ level_code/level_name ดังนั้นไม่ต้องส่ง
        }

        try {
            const response = await this.$http.post(url, data);
            const result = response.data;

            if (result && result.status === true) {
                this.showSnackbar(
                    "success",
                    this.isAdding ? "เพิ่มข้อมูลสำเร็จ" : "แก้ไขข้อมูลสำเร็จ"
                );
                this.fetchDegrees();
                this.closeDialog();
            } else {
                this.showSnackbar(
                    "error",
                    `ดำเนินการไม่สำเร็จ: ${JSON.stringify(result)}`
                );
            }
        } catch (error) {
            console.error("API Error (save):", error);
            this.showSnackbar("error", "เกิดข้อผิดพลาดในการบันทึกข้อมูล");
        }
    },

    /**
     * เปิด Dialog ยืนยันการลบ
     */
    deleteItem(item) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    },

    /**
     * ยืนยันและดำเนินการลบ (Delete)
     * API: cls_degree.delete.php
     */
    async confirmDelete() {
      this.deleteDialog = false;
      if (!this.itemToDelete || !this.itemToDelete.degree_id) {
        this.showSnackbar("error", "ไม่พบ ID ที่ต้องการลบ");
        return;
      }

      try {
        const response = await this.$http.post("cls_degree.delete.php", {
          ApiKey: this.ApiKey,
          degree_id: this.itemToDelete.degree_id
        });
        const result = response.data;

        if (result && result.status === true) {
          this.showSnackbar("success", "ลบข้อมูลสำเร็จ");
          this.fetchDegrees();
        } else {
          this.showSnackbar(
            "error",
            `ลบข้อมูลไม่สำเร็จ: ${JSON.stringify(result)}`
          );
        }
      } catch (error) {
        console.error("API Error (delete):", error);
        this.showSnackbar("error", "เกิดข้อผิดพลาดในการลบข้อมูล");
      }
      this.itemToDelete = null;
    },

    /**
     * ปิด Dialog และรีเซ็ตข้อมูลชั่วคราว
     */
    closeDialog() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.isAdding = true;
      });
    },

    /**
     * แสดง Snackbar แจ้งเตือน
     */
    showSnackbar(color, message) {
      this.snackbar.color = color;
      this.snackbar.message = message;
      this.snackbar.show = true;
    }
  }
};
</script>

<style scoped>
/* สามารถใส่ CSS ที่ต้องการได้ที่นี่ */
</style>